var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.96875C3.75391 0.96875 0.71875 4.00391 0.71875 7.75C0.71875 11.4961 3.75391 14.5312 7.5 14.5312C11.2461 14.5312 14.2812 11.4961 14.2812 7.75C14.2812 4.00391 11.2461 0.96875 7.5 0.96875ZM10.8086 9.55469C10.9453 9.66406 10.9453 9.88281 10.8086 10.0195L9.74219 11.0859C9.60547 11.2227 9.38672 11.2227 9.27734 11.0859L7.5 9.28125L5.69531 11.0859C5.58594 11.2227 5.36719 11.2227 5.23047 11.0859L4.16406 9.99219C4.02734 9.88281 4.02734 9.66406 4.16406 9.52734L5.96875 7.75L4.16406 5.97266C4.02734 5.86328 4.02734 5.64453 4.16406 5.50781L5.25781 4.44141C5.36719 4.30469 5.58594 4.30469 5.72266 4.44141L7.5 6.21875L9.27734 4.44141C9.38672 4.30469 9.60547 4.30469 9.74219 4.44141L10.8086 5.50781C10.9453 5.64453 10.9453 5.86328 10.8086 5.97266L9.03125 7.75L10.8086 9.55469Z",
    fill: "#E03535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.896d484c7ca614f00dacd78d2b67f105.svg";
export { ForwardRef as ReactComponent };